export default {"src":"/_next/static/media/relationship-interaction.colour.a2361f92.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};